import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "article-teaser__content" }
const _hoisted_2 = {
  key: 0,
  class: "article-teaser__image-wrapper"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "article-teaser__text-content" }
const _hoisted_5 = { class: "article-teaser__wrap-text" }
const _hoisted_6 = {
  key: 0,
  class: "article-teaser__date"
}
const _hoisted_7 = {
  key: 1,
  class: "slide__date"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "article-teaser__text" }, null, -1)
const _hoisted_11 = {
  key: 3,
  class: "slide__text article__text-long"
}
const _hoisted_12 = {
  key: 0,
  class: "article-teaser__link"
}
const _hoisted_13 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["teasers__cell article-teaser", { 'article-teaser--loading': _ctx.loading, 'article-teaser--image': _ctx.showImage, 'article-teaser--cover': _ctx.large }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showImage && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.imageMd && _ctx.imageLg)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "article-teaser__image",
                  src: _ctx.large ? _ctx.imageLg : _ctx.imageMd,
                  alt: _ctx.fileName
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createBlock(_component_icon, {
                  key: 1,
                  class: "article-teaser__placeholder",
                  name: "icn-placeholder"
                }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : (_ctx.date)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.date), 1))
              : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _hoisted_8,
                _hoisted_9,
                _hoisted_10
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.description), 1))
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : (_ctx.link)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _ctx.link,
                target: _ctx.determineTarget(),
                class: "button button--borderless"
              }, _toDisplayString(_ctx.readMoreLabel), 9, _hoisted_13))
            : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}